module.exports = __webpack_public_path__ + "img/aurora-rectangle-top-angle.0b6dbef9.png";